export const consts = {
  componentName: "canvas-mapping-link",
  canvasId: "map_canvas",
  canvasStrokeColor: "#3b97e3",
  CompType: "comp_type",
  CompTypeName: "mapping",
  buttonName: "draw-box",
  wrapperName: "Parent-Wrapper",
  typeTraitName: "dynamic-type",
  traitTypes: {
    linkId: "link",
    veevaLinkId: "veeva-link",
    // modalTriggerId: "modal-trigger",
    docLinkId: "Doc-Link",
    customPopupTrigger: "popup-trigger",
    customPopupClose: "popup-close"
  }
};